import { FeatureFlagService } from './services/feature-flag.service';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { LogoutConfirmationComponent } from './components/logout-confirmation/logout-confirmation.component';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HeroComponent } from './components/hero/hero.component';
import { AmountDirective } from './directives/amount.directive';
import { GuidanceComponent } from './components/guidance/guidance.component';
import { CommonModule, DatePipe } from '@angular/common';
import { GuidanceItemComponent } from './components/guidance-item/guidance-item.component';
import { EstimateChartComponent } from './components/estimate-chart/estimate-chart.component';
import { LottieModule } from 'ngx-lottie';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TitleComponent } from './components/title/title.component';
import { HintComponent } from './components/hint/hint.component';
import { ScrollTopDirective } from './directives/scroll-top.directive';
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr';
import { IconComponent } from './components/icon/icon.component';
import { IllustrationComponent } from './components/illustration/illustration.component';
import { SignedCurrencyPipe } from './pipes/signed-currency.pipe';
import { MaxMinValidatorDirective } from './directives/max-min-validator.directive';
import { CustomScrollDirective } from './directives/custom-scroll.directive';
import { InlineErrorComponent } from './components/inline-error/inline-error.component';
import { CalculativeScrollDirective } from './directives/calculative-scroll.directive';
import { ScrollProgressDirective } from './directives/scroll-progress.directive';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import { ModalComponent } from './components/modal/modal.component';
import { RecaptchaDirective } from './directives/recaptcha.directive';
import { NationalnumberDirective } from './directives/nationalnumber.directive';
import { NumberDirective } from './directives/number.directive';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { ExpiryDateValidatorDirective } from './directives/expiry-date-validator.directive';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CTAContainerComponent } from './components/cta-container/cta-container.component';
import { RadioBlockComponent } from './components/radio-block/radio-block.component';
import { HelpWidgetComponent } from './components/help-widget/help-widget.component';
import { HelpWidgetDirective } from './directives/help-widget.directive';
import { BrokerToolComponent } from './components/broker-tool/broker-tool.component';
import { SilStepperComponent } from './components/sil-stepper/sil-stepper.component';
import { FormTrackingDirective } from './directives/tracking.directive';
import { NgOtpInputModule } from 'ng-otp-input';
import { CoverflowComponent } from './components/coverflow/coverflow.component';
import { SilLoadingComponent } from './components/sil-loading/sil-loading.component';
import { PreloadAssetService } from './services/preload-asset.service';
import { ConstantService } from './services/constant.service';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { MatchHeightDirective } from './directives/match-height.directive';
import { CalculationGuidanceItemComponent } from './components/calculation-guidance-item/calculation-guidance-item.component';
import { IbannumberDirective } from './directives/ibannumber.directive';
import { DynamicHeaderComponent } from './components/dynamic-header/dynamic-header.component';
import { SilStepsComponent } from './components/sil-steps/sil-steps.component';
import { EditWindowComponent } from './components/edit-window/edit-window.component';
import { PartialWindowComponent } from './components/partial-window/partial-window.component';
import { ColumnLayoutComponent } from './components/column-layout/column-layout.component';
import { BannerComponent } from './components/banner/banner.component';
import { FloatingButtonDirective } from './directives/floating-button.directive';
import { SideNavigatingMenuComponent } from './components/side-navigating-menu/side-navigating-menu.component';
import { SideNavigationDirective } from './directives/side-navigation.directive';
import { TipComponent } from './components/tip/tip.component';
import { BarometerComponent } from './components/barometer/barometer.component';
import { InlineToastComponent } from './components/inline-toast/inline-toast.component';
import { TimerComponent } from './components/timer/timer.component';
import { GlobalBlockedComponent } from './components/blocked/blocked.component';
import { InfoTextComponent } from './components/info-text/info-text.component';
import { VideoModalComponent } from './components/video-modal/video-modal.component';
import { CloudBackgroundComponent } from './components/cloud-background/cloud-background.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { PhoneHrefPipe } from './pipes/phone-href.pipe';
import { VoiceAssistanceComponent } from './components/voice-assistance/voice-assistance.component';
import { PlayerProgressComponent } from './components/voice-assistance/player-progress.component';
import { EsignHandlerComponent } from './components/esign-handler/esign-handler.component';
import { TwoLevelDisplayerComponent } from './components/two-level-displayer/two-level-displayer.component';
import { WarningBannerComponent } from './components/warning-banner/warning-banner.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { CalendarComponent } from './components/calendar/calendar.component';
import { PunctuationWrapPipe } from './pipes/punctuation-wrap.pipe';
import { AgSelectModule, AgUiModule } from '@ag/vc.ag-ui';
import { IfLangDirective } from './directives/ifLang.directive';
import { PaymentDetailsComponent } from './components/payment-details/payment-details.component';
import { ErrorScreenComponent } from './components/error-screen/error-screen.component';

@NgModule({
  declarations: [
    HeroComponent,
    GuidanceComponent,
    GuidanceItemComponent,
    AmountDirective,
    EstimateChartComponent,
    TitleComponent,
    HintComponent,
    ScrollTopDirective,
    IconComponent,
    IllustrationComponent,
    InfoTextComponent,
    SignedCurrencyPipe,
    PhoneHrefPipe,
    MaxMinValidatorDirective,
    InlineErrorComponent,
    CustomScrollDirective,
    CalculativeScrollDirective,
    ScrollProgressDirective,
    ScrollTopComponent,
    ModalComponent,
    RecaptchaDirective,
    NationalnumberDirective,
    NumberDirective,
    ExpiryDateValidatorDirective,
    CTAContainerComponent,
    RadioBlockComponent,
    FormTrackingDirective,
    HelpWidgetComponent,
    HelpWidgetDirective,
    BrokerToolComponent,
    SilStepperComponent,
    CoverflowComponent,
    SilLoadingComponent,
    MatchHeightDirective,
    CalculationGuidanceItemComponent,
    IbannumberDirective,
    DynamicHeaderComponent,
    SilStepsComponent,
    EditWindowComponent,
    PartialWindowComponent,
    ColumnLayoutComponent,
    BannerComponent,
    FloatingButtonDirective,
    SideNavigatingMenuComponent,
    SideNavigationDirective,
    TipComponent,
    BarometerComponent,
    TimerComponent,
    InlineToastComponent,
    GlobalBlockedComponent,
    VideoModalComponent,
    CloudBackgroundComponent,
    DocumentListComponent,
    LogoutConfirmationComponent,
    VoiceAssistanceComponent,
    PlayerProgressComponent,
    EsignHandlerComponent,
    TwoLevelDisplayerComponent,
    WarningBannerComponent,
    FeatureFlagDirective,
    CalendarComponent,
    PunctuationWrapPipe,
    IfLangDirective,
    PaymentDetailsComponent,
    ErrorScreenComponent
  ],
  imports: [
    CommonModule,
    AgUiModule.forChild(),
    LottieModule.forRoot({ player: playerFactory }),
    FormsModule,
    ToastrModule.forRoot({ positionClass: 'inline' }),
    ToastContainerDirective,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    DropzoneModule,
    PopoverModule.forRoot(),
    // AgFormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgOtpInputModule,
    AccordionModule.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule,
    AgSelectModule
  ],
  exports: [
    RecaptchaDirective,
    HeroComponent,
    GuidanceComponent,
    GuidanceItemComponent,
    AmountDirective,
    AgUiModule,
    FormsModule,
    EstimateChartComponent,
    TitleComponent,
    HintComponent,
    ScrollTopDirective,
    IconComponent,
    IllustrationComponent,
    InfoTextComponent,
    SignedCurrencyPipe,
    PhoneHrefPipe,
    MaxMinValidatorDirective,
    InlineErrorComponent,
    CustomScrollDirective,
    CalculativeScrollDirective,
    ScrollProgressDirective,
    ScrollTopComponent,
    ModalComponent,
    NationalnumberDirective,
    NumberDirective,
    ExpiryDateValidatorDirective,
    LottieModule,
    ToastrModule,
    TooltipModule,
    PopoverModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    IconComponent,
    CTAContainerComponent,
    RadioBlockComponent,
    FormTrackingDirective,
    HelpWidgetComponent,
    HelpWidgetDirective,
    BrokerToolComponent,
    SilStepperComponent,
    NgOtpInputModule,
    CoverflowComponent,
    SilLoadingComponent,
    MatchHeightDirective,
    CalculationGuidanceItemComponent,
    IbannumberDirective,
    DynamicHeaderComponent,
    SilStepsComponent,
    EditWindowComponent,
    PartialWindowComponent,
    ColumnLayoutComponent,
    BannerComponent,
    FloatingButtonDirective,
    SideNavigatingMenuComponent,
    SideNavigationDirective,
    BarometerComponent,
    InlineToastComponent,
    TipComponent,
    TimerComponent,
    VideoModalComponent,
    CloudBackgroundComponent,
    DocumentListComponent,
    LogoutConfirmationComponent,
    VoiceAssistanceComponent,
    PlayerProgressComponent,
    TwoLevelDisplayerComponent,
    WarningBannerComponent,
    FeatureFlagDirective,
    RecaptchaModule,
    RecaptchaFormsModule,
    CalendarComponent,
    PunctuationWrapPipe,
    IfLangDirective,
    AgSelectModule,
    PaymentDetailsComponent
  ],
  providers: [DatePipe, PunctuationWrapPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        PreloadAssetService,
        ConstantService,
        FeatureFlagService
      ]
    };
  }
}

export function playerFactory() {
  return import('lottie-web');
}
